const LOOP_DOGS_CARD_DOG_SVG = html`<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M23.0001 23V24C23.0001 25.275 22.1501 26.386 21.0001 26.81V30.999H19.0001V26.81C17.8501 26.386 17.0001 25.275 17.0001 24V23H23.0001ZM24.0001 17C25.6261 17 27.0001 18.374 27.0001 20H25.0001C25.0001 19.486 24.5141 19 24.0001 19C23.4851 19 22.9991 19.486 22.9991 20H20.9991C20.9991 18.374 22.3741 17 24.0001 17ZM16.0001 17C17.6251 17 18.9991 18.374 18.9991 20H16.9991C16.9991 19.486 16.5141 19 16.0001 19C15.4861 19 15.0001 19.486 15.0001 20H13.0001C13.0001 18.374 14.3741 17 16.0001 17ZM30.3116 31.085C28.5316 33.5 24.5796 35 19.9986 35C15.4186 35 11.4686 33.501 9.68862 31.087C8.81062 29.895 8.55662 28.584 8.95562 27.296L9.20362 26.498C10.1356 23.51 10.2336 23.198 10.9926 17.124C11.5626 12.559 15.9276 10.515 19.9996 10.515C24.0726 10.515 28.4366 12.559 29.0076 17.124C29.7666 23.195 29.8636 23.508 30.7956 26.494L31.0446 27.296C31.4436 28.583 31.1896 29.894 30.3116 31.085ZM6.99962 7.15903C7.05162 7.09303 7.13462 7.01103 7.11562 7.00203C10.3906 6.69203 12.9766 8.49703 14.3636 9.76603C12.3446 10.727 10.6266 12.258 9.69062 14.404C7.00862 11.785 6.97662 8.67703 6.99962 7.15903ZM32.7896 6.98203C32.8466 7.00703 32.9446 7.09303 32.9996 7.16003C33.0236 8.65403 33.0016 11.774 30.3096 14.404C29.3736 12.258 27.6556 10.726 25.6356 9.76603C27.0196 8.49403 29.5916 6.68203 32.7896 6.98203ZM32.7046 25.898C31.8026 23.007 31.7286 22.771 30.9926 16.876C30.9776 16.756 30.9486 16.646 30.9286 16.527C35.0886 13.121 35.0266 8.70703 34.9976 6.99803C34.9796 6.02303 33.9246 5.09103 33.0726 5.01203C28.3546 4.55503 24.8886 7.60503 23.5666 8.99603C22.3896 8.67403 21.1746 8.51503 19.9996 8.51503C18.8256 8.51503 17.6106 8.67403 16.4336 8.99603C15.1106 7.60703 11.6386 4.57503 6.92862 5.01103C6.09262 5.09003 5.01862 6.04103 5.00162 7.01903C4.97262 8.70703 4.91062 13.12 9.07162 16.527C9.05162 16.646 9.02262 16.756 9.00762 16.876C8.27062 22.772 8.19662 23.009 7.29462 25.902L7.04462 26.704C6.45862 28.597 6.82662 30.574 8.07962 32.273C10.2606 35.233 14.7166 37 19.9986 37C25.2816 37 29.7396 35.232 31.9216 32.272C33.1736 30.573 33.5406 28.596 32.9556 26.704L32.7046 25.898Z"
    fill="black"
  />
</svg>`;

class LoopDogsCard extends HTMLElement {
  constructor() {
    super();
    this.dogs = [];
    // Dogs come from a remote DB, so start in a loading state and show
    // skeleton placeholders instead of an empty list.
    this.loading = true;
  }

  connectedCallback() {
    this.render();
    this.fetchDogs();
    window.LoopUI.drawerContent.yourDogs().then((data) => {
      this.dogsDrawerInfo = data;
    });
  }

  skeletonList() {
    return Array.from(
      { length: LoopDogsCard.skeletonCount },
      () => html`<div class="ldc-dog-card ldc-dog-card--skeleton"></div>`,
    ).join("");
  }

  dogList() {
    return this.dogs
      .map((dog, index) => {
        const photoUrl = window.LoopUtils.getDogPhotoUrl(dog);
        const name = window.LoopUtils.escapeHtml(dog.name);

        if (photoUrl) {
          return html`<div
            class="ldc-dog-card ldc-dog-card--photo"
            title="${name}"
          >
            <img
              src="${window.LoopUtils.escapeHtml(photoUrl)}"
              alt="${name}"
              loading="lazy"
            />
          </div>`;
        }

        return html`<div
          class="ldc-dog-card"
          title="${name}"
          style="background-color: ${
            LoopDogsCard.dogsColors[index] || "aquamarine"
          }"
        >
          ${LOOP_DOGS_CARD_DOG_SVG}
        </div>`;
      })
      .join("");
  }

  render() {
    // An empty list after a failed fetch would read as "you have no dogs" —
    // show the failure and a retry instead.
    let body;
    if (this.error) {
      body = html`<p class="ldc-error">${window.t("dogs.loadError")}</p>`;
    } else if (!this.loading && this.dogs.length === 0) {
      body = html`<p class="ldc-empty">${window.t("dogs.noDogs")}</p>`;
    } else {
      body = html`<div
        class="ldc-dog-list ${this.loading ? "ldc-dog-list--loading" : ""}"
      >
        ${this.loading ? this.skeletonList() : this.dogList()}
      </div>`;
    }

    this.innerHTML = html`
      <div>
        <div class="ldc-title">
          <span> ${window.t("dogs.yourDogs")} </span>
          <button ${this.loading ? "disabled" : ""}>
            ${this.error ? window.t("ui.retry") : window.t("ui.see")}
          </button>
        </div>
        ${body}
      </div>
    `;

    this.querySelector("button").addEventListener("click", async () => {
      if (this.error) {
        window.LoopFeatures.dogs._invalidateCache();
        this.error = false;
        this.loading = true;
        this.render();
        this.fetchDogs();
        return;
      }

      if (!this.dogsDrawerInfo) return;
      window.LoopUI.drawer.createDrawer(this.dogsDrawerInfo);
    });
  }

  async fetchDogs() {
    try {
      const data = await window.LoopFeatures.dogs.getAllDogs();
      this.dogs = data || [];
      // getAllDogs swallows the error and returns [], so read the flag it sets.
      this.error = !!window.LoopFeatures.dogs._lastError;
    } catch (e) {
      console.error(e);
      this.dogs = [];
      this.error = true;
    } finally {
      this.loading = false;
      this.render();
    }
  }

  static dogsColors = ["rgba(255, 220, 151, 1)", "rgba(255, 171, 173, 1)"];
  static skeletonCount = 2;
}

if (!customElements.get("loop-dogs-card")) {
  customElements.define("loop-dogs-card", LoopDogsCard);
}
